import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AdminAddProduct from './AdminAddProduct';
import { List, ListItem, ListItemText, Box, Divider } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { printOrder } from "./PrintOrder";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AdminEditProductDialog({ open, handleClose, order }) {

  const API_BASE =
    import.meta?.env?.VITE_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    ""; // להתאים לפורט שלך

  const resolveImgSrc = (img) => {
    if (!img) return null;
    if (img instanceof File) return URL.createObjectURL(img);
    const path = String(img).replace(/\\/g, "/"); // ליתר ביטחון אם הגיעו backslashes
    if (path.startsWith("http") || path.startsWith("//")) return path;
    return `${API_BASE}${path}`; // הופך "/       /..." ל־"https://localhost:7010/uploads/..."
  };



  const handlePrint = () => {
    printOrder(order, resolveImgSrc);
  };

  const translateOptionType = (type) => {
    switch (type) {
      case "Color":
        return "צבע";
      case "Size":
        return "מידה";
      default:
        return type; // fallback אם יתווסף סוג בעתיד
    }
  };


  return (
    <>
      {/* <AdminAddProduct/> */}
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg" // אפשר "lg" אם את רוצה יותר גדול  

      >
        {/* .... */}

        <DialogTitle sx={{ m: 0, p: 2, position: "relative", pr: 6 }} id="customized-dialog-title">
          פרטי הזמנה

          <IconButton
            aria-label="print"
            onClick={handlePrint}
            sx={{
              position: 'absolute',
              left: 8,          // אם RTL, אפשר לשים ב-right: 8
              top: 8,
            }}
          >
            <PrintIcon />
          </IconButton>
        </DialogTitle>

        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <DialogContent dividers>
          <Box id={`order-print-${order.id}`}>
            {/* <Typography gutterBottom>
           {JSON.stringify(order)}
          </Typography> */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                פרטי לקוח
              </Typography>
              <Typography>שם: {order.user?.name}</Typography>
              <Typography>אימייל: {order.user?.email}</Typography>
              <Typography>טלפון: {order.user?.phone}</Typography>
              <Typography>כתובת: {order.user?.address}</Typography>
            </Box>
            <Divider sx={{ mx: -2, my: 2, borderColor: "rgba(0,0,0,0.12)" }} />
            <List className="print-products-list">
              {order.ordersProducts.map((orderProduct) => {
                const optionText = orderProduct.productOption
                  ? `${translateOptionType(orderProduct.productOption.optionType)}: ${orderProduct.productOption.value}`
                  : null;


                return (
                  <React.Fragment key={orderProduct.id}>
                    <ListItem>
                      <Box
                        component="img"
                        src={resolveImgSrc(orderProduct.product?.image)}
                        alt={orderProduct.product?.name}
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: 1,
                          objectFit: "cover",
                          ml: 2,
                        }}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />

                      <ListItemText
                        primary={
                          <>
                            <Typography sx={{ fontWeight: 600 }}>
                              {orderProduct.product?.name}
                              {optionText && ` (${optionText})`}
                            </Typography>

                          </>
                        }
                        secondary={(() => {
                          const basePrice = Number(orderProduct.product?.price) || 0;
                          const optionPrice = Number(orderProduct.productOption?.extraPrice) || 0; // מחיר וריאציה (אצלך מחיר סופי)
                          const unitPrice = optionPrice > 0 ? optionPrice : basePrice;

                          const amount = Number(orderProduct.amount) || 0;
                          const lineTotal = unitPrice * amount;

                          return `כמות: ${amount} × ${unitPrice.toFixed(2)} ש"ח | סה"כ: ${lineTotal.toFixed(2)} ש"ח`;
                        })()}

                        sx={{ ml: 2, textAlign: "right" }}
                      />
                    </ListItem>
                  </React.Fragment>
                );
              })}
            </List>

            <Typography>סהכ לתשלום : ₪{order?.totalCost}</Typography>

            {/* פרטי הזמנה ולקוח */}



          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button autoFocus onClick={handleClose}>
            Save changes
          </Button> */}
          <Button autoFocus onClick={handleClose}>
            ביטול          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}